import { render, staticRenderFns } from "./DataViewSidebarSites.vue?vue&type=template&id=038cc8ba&scoped=true&"
import script from "./DataViewSidebarSites.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarSites.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarSites.vue?vue&type=style&index=0&id=038cc8ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038cc8ba",
  null
  
)

export default component.exports